import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminLayoutComponent } from 'app/layouts/admin/admin-layout.component';
import { BandejajudicialexpedientesComponent } from './bandejajudicialexpedientes/bandejajudicialexpedientes.component';
import { JudicialComponent } from './judicial/judicial.component';


const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    data: {
      breadcrumb: 'Judicial'
    },
    children: [
      {
        path: 'judicial',
        component: JudicialComponent,
        data: {
          breadcrumb: 'Documentos Protestados'
        }
      },
      {
        path: 'expedientes-judiciales',
        component: BandejajudicialexpedientesComponent,
        data: {
          breadcrumb: 'Expedientes Judiciales'
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JudicialesRoutingModule { }
